<template>
  <b-input-group>
    <b-form-select
      class="rounded-0"
      :value="comparatorType"
      :options="comparatorOptions"
      @change="updateComparatorType"
    >
      <template slot="first">
        <option :value="null" disabled>
          -- Select comparator --
        </option>
      </template>
    </b-form-select>
  </b-input-group>
</template>

<script>
import {
  COMPARATOR_TYPES_LABELS,
  RESPONSE_VALUES_COMPARATORS,
} from '@/store';
export default {
  name: 'ResponseValidationOperatorSelector',
  props: {
    variable: Object,
    comparator: {
      type: Object,
      default: () => null,
    },
  },
  computed: {
    comparatorOptions: function () {
      return RESPONSE_VALUES_COMPARATORS.map((comparatorKey) => ({
        value: comparatorKey,
        text: COMPARATOR_TYPES_LABELS[comparatorKey],
      }));
    },
    comparatorType: function () {
      return this.comparator ? this.comparator.type : null;
    },
  },
  methods: {
    updateComparatorType: function (type) {
      const newComparator = {
        type: type,
      };
      this.$emit('update-comparator', this.variable.id, newComparator);
    },
  },
};
</script>

<style scoped></style>
